import type { LessonFigure } from '../../../lib/api.js'
import { Icon } from '../../../classroom/icons.js'
import { usePlayer } from './context.js'

/**
 * A picture the lesson points at („Zobacz obrazek (Grafika 4)”), served
 * behind the enrolment check. Until Diana uploads it, the place is held and
 * says so honestly — the state the spec sheet calls „Brak obrazka”.
 */
export function FigureC({ figure }: { figure: LessonFigure }) {
  const { t } = usePlayer()
  return (
    <figure className="my-5 mx-0">
      {figure.mediaId ? (
        <img
          src={`/api/course/media/${figure.mediaId}`}
          alt={`Grafika ${figure.n}`}
          loading="lazy"
          className="w-full rounded-class-md bg-class-white shadow-[inset_0_0_0_1px_var(--color-class-hairline)]"
        />
      ) : (
        <div className="flex flex-col items-center justify-center gap-2 rounded-class-md border border-dashed border-class-sky-200 bg-class-field-soft/60 px-5 py-10 text-class-ink-soft">
          <Icon name="image" className="text-class-sky-700" />
          <span className="text-class-gloss font-semibold">{t.figure.pending(figure.n)}</span>
        </div>
      )}
    </figure>
  )
}
